import * as React from 'react';
import { preparePagination } from '../utils/preparePagination';
export function usePagination(_ref) {
  let {
    currentPage,
    lastPage
  } = _ref;
  const pages = React.useMemo(() => preparePagination({
    currentPage,
    totalPages: lastPage
  }), [currentPage, lastPage]);
  const isPrevButtonEnabled = React.useMemo(() => currentPage > 1, [currentPage]);
  const isNextButtonEnabled = React.useMemo(() => currentPage < lastPage, [currentPage, lastPage]);
  return {
    pages,
    isPrevButtonEnabled,
    isNextButtonEnabled
  };
}